import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import {
  getCountryCodeFromPhoneNumber,
  getPhoneNumberAsE164,
} from '@ds/components/InputPhone'

export function getFormattedPhoneNumber(
  defaultCountry: MarketCountryCode,
  dialCode?: string,
  phoneNumber?: string,
) {
  if (!phoneNumber || !dialCode) {
    return null
  }

  const fullPhoneNumber = `${dialCode}${phoneNumber}`
  const countryCode =
    getCountryCodeFromPhoneNumber(fullPhoneNumber) || defaultCountry

  return getPhoneNumberAsE164(fullPhoneNumber, countryCode)
}
